import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconColumnWide"><Path d="M11 4H2V20H11V4Z" fill="currentColor"/><Path d="M13 20H22V4H13V20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWide;
